import LineGraph from './line-graph';
export default LineGraph;